module.exports = __webpack_public_path__ + "img/valina_terminal.05f11668.png";